import { render } from "./App.vue?vue&type=template&id=3fd70188"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3fd70188&lang=scss"
script.render = render

export default script